import React from 'react';
import { LegalDocumentLink } from '../LegalDocumentLink/LegalDocumentLink';
import './PortalPageFooter.css';

export const PortalPageFooter: React.FC = () => {
  const copyrightYear = new Date().getFullYear();

  return (
    <footer className="portal-page-footer">
      <div className="portal-page-footer-inner">
        <p className="portal-page-footer-text">
          © {copyrightYear} Healthesus. All rights reserved.{' '}
          <LegalDocumentLink document="privacy" className="portal-page-footer-link">
            Privacy Policy
          </LegalDocumentLink>
        </p>
      </div>
    </footer>
  );
};
